<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
    <template #details="{ visible, params }">
      <Details :rows="params" v-if="visible" />
    </template>
  </cTable>
</template>

<script>
import { getPages, getDetails, saveDetails } from "@/api/auth/button";

import cTable from "@/base/common/index";
import Details from "./details";
import { read } from "@/libs/excel";

export default {
  name: "pageButton",
  components: {
    cTable,
    Details,
  },
  data() {
    return {
      methods: {
        list: getPages,
        getDetails,
        saveDetails,
      },
      config: {
        height: 630,
        showOverflow: false,
      },
      footer: {
        show: () => true,
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              console.log(row);
              let data = {
                id: row.id,
                button: this.list,
              };
              this.$page
                .handleRequestMethods("saveDetails", data)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 800,
              draggable: true,
            },
            title: this.$t("update") + this.$t("configuration"),
          },
          table: {
            config: {
              height: 500,
            },
            fields: [
              {
                name: "ID",
                key: "id",
                width: 100,
              },
              {
                name: this.$t("btn_name"),
                key: "zh_title",
                component: "Input",
                width: 150,
                placeholder() {
                  return this.$t("enter") + this.$t("btn_name");
                },
              },
              {
                name: this.$t("rearEnd") + "api",
                key: "path_uri",
                component: "Input",
                placeholder() {
                  return this.$t("enter") + this.$t("rearEnd") + "api";
                },
              },
              {
                type: "btns",
                width: 160,
                name: () => this.$t("operation"),
                fixed: "right",
                // width({ field }) {
                //   return field.list.length * 40 + 40;
                // },
                list: [
                  {
                    name: () => this.$t("add"),
                    type: "add",
                    fnName: "add",
                    bind: {
                      type: "warning",
                    },
                    icon: "md-add",
                    show({ rowIndex }) {
                      return rowIndex == 0;
                    },
                  },
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "delete",
                    icon: "md-trash",
                    // disabled({ rowIndex }) {
                    //   return rowIndex == 0;
                    // },
                    show({ rowIndex }) {
                      return rowIndex != 0;
                    },
                  },
                ],
                methods: {
                  add() {
                    let data = {
                      id: "",
                      zh_title: "",
                      path_uri: "",
                    };
                    this.getModal("add").list.unshift(data);
                  },
                  delete({ row, rowIndex }) {
                    if (!row.id) {
                      this.getModal("add").list.splice(rowIndex, 1);
                    } else {
                      this.$Modal.confirm({
                        title: this.$t("delete"),
                        width: 300,
                        content: this.$t("titleModal"),
                        onOk: () => {
                          this.getModal("add").list.splice(rowIndex, 1);
                        },
                      });
                    }
                  },
                },
              },
            ],
          },
        },
        showDetails: {
          footer: {
            show: false,
          },
          contentSlot: "details",
          config: {
            modalBind: {
              width: 60,
              draggable: true,
              sticky: true,
            },
          },
          footer: {
            show: () => false,
          },
        },
      },
      header: {
        config: {
          custom: false,
        },
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("updateFile"),
              fnName: "updateFile",
              component: "Upload",
              bind: {
                showUploadList: false,
                icon: "ios-cloud-upload",
                type: "warning",
              },
              // 前端账号id判断
              show: ({ row }) =>
                [3265, 47].indexOf(this.$store.getters.userId) != -1,
            },
          ],
          methods: {
            updateFile({ file, searchForm, field }) {
              // 首字母大写
              const titleCase = (str) => {
                var newStr = str.replace(/[^a-zA-Z0-9]/g, " ").split(" ");
                for (var i = 0; i < newStr.length; i++) {
                  newStr[i] =
                    newStr[i].slice(0, 1).toUpperCase() +
                    newStr[i].slice(1).toLowerCase();
                }
                return newStr.join(" ").replace(/\s+/g, "");
              };
              let reader = new FileReader();
              //启动函数
              reader.readAsBinaryString(file);
              //onload在文件被读取时自动触发
              reader.onload = (e) => {
                try {
                  let data = read(e.target.result, "binary").results;
                  let objC = {};
                  let objE = {};
                  let publicC = {};
                  let publicE = {};
                  let keyE = "";
                  data.forEach((el) => {
                    if (el) {
                      if (el.key) keyE = el.key + "Child";
                      if (!objE[el.key] && !objC[el.key]) {
                        objE[el.key] = {
                          public: {},
                          [keyE]: {},
                        };
                        objC[el.key] = {
                          public: {},
                          [keyE]: {},
                        };
                      }
                      console.log(objE);
                      if (el.pageE && el.pageC) {
                        objE[el.key][keyE][el.pageKey] = el.pageE;
                        objC[el.key][keyE][el.pageKey] = el.pageC;
                      }
                      if (el.all) {
                        publicE[titleCase(el.textE)] = el.textC;
                        publicC[titleCase(el.textE)] = el.textE;
                      }
                      if (el.public) {
                        objE[el.key]["public"][titleCase(el.textE)] = el.textC;
                        objC[el.key]["public"][titleCase(el.textE)] = el.textE;
                      }
                      if (
                        !!objE[el.key][keyE][el.pageKey][titleCase(el.textE)] &&
                        !!objC[el.key][keyE][el.pageKey][titleCase(el.textE)]
                      ) {
                        objE[el.key][keyE][el.pageKey][titleCase(el.textE)] =
                          el.textC;
                        objC[el.key][keyE][el.pageKey][titleCase(el.textE)] =
                          el.textE;
                      } else {
                        objE[el.key][keyE][el.pageKey] = {
                          [titleCase(el.textE)]: el.textC,
                        };
                        objC[el.key][keyE][el.pageKey] = {
                          [titleCase(el.textE)]: el.textE,
                        };
                      }
                    }
                  });
                  console.log(JSON.stringify(objE));
                  console.log(JSON.stringify(objC));
                  console.log(JSON.stringify(publicE));
                  console.log(JSON.stringify(publicC));
                } catch (error) {
                  this.$Message.warning("文件类型不正确！");
                }
              };
              return false;
            },
          },
        },
      },
      fields: [
        {
          name: () => this.$t("pageName"),
          key: "zh_title",
          width: 200,
          align: "left",
        },
        {
          name: () => this.$t("btn_lis"),
          key: "button",
          align: "left",
          render: (h, { row }) => {
            if (row.button.length > 0) {
              return h("div", [
                row.button.map((item, index) => {
                  return h(
                    "Button",
                    {
                      props: {
                        type: index % 2 == 0 ? "info" : "success",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                        marginBottom: "5px",
                      },
                      on: {
                        click: () => {
                          if (this.$hasPermission(997)) {
                            this.$refs["table"]
                              .getModal("showDetails")
                              .open(item, function () {
                                this.setTitle(
                                  this.$t("bind") + this.$t("role_t")
                                );
                              });
                          }
                        },
                      },
                    },
                    item.zh_title
                  );
                }),
              ]);
            }
          },
        },
        {
          type: "btns",
          width: 80,
          name: () => this.$t("operation"),
          id: 442,
          // fixed: "right",
          // // width({ field }) {
          // //   return field.list.length * 40 + 40;
          // // },
          list: [
            {
              name: this.$t("configuration"),
              type: "update",
              fnName: "update",
              bind: {
                type: "warning",
              },
            },
          ],
          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then((res) => {
                let data = res.payload;
                data.unshift({
                  id: "",
                  zh_title: "",
                  path_uri: "",
                });
                this.getModal("add").open(row, function () {
                  this.list = data;
                });
              });
            },
          },
        },
      ],
    };
  },
};
</script>
